import { jsx as e } from "react/jsx-runtime";
import * as n from "react";
import a from "../themes/styled.js";
import { c as m } from "../index-e0f6271a.js";
import "../styled-a6aa6ca0.js";
import "../createTheme-ef7fa3a1.js";
import "../objectWithoutPropertiesLoose-1e2b28af.js";
import "../_commonjsHelpers-c5d32002.js";
import "../extends-e3d0fd9d.js";
import "../extends-0a3e0827.js";
import "../index-057d60ee.js";
import "../extendSxProp-10687d60.js";
import "@emotion/styled";
import "@emotion/react";
import "../GlobalStyles-bdd9f9fb.js";
import "../defaultTheme-9f1e13f4.js";
import "../identifier-2b569a98.js";
const s = /* @__PURE__ */ new Set(["as", "family", "sx"]), p = (t) => !s.has(t), f = a("p", {
  shouldForwardProp: p,
  name: "Text",
  slot: "root"
})(({ theme: t, family: o = "sans" }) => ({
  color: t.palette["text/contrast-high"],
  fontFamily: t.typography[o],
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontSize: t.spacing(2),
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "150%",
  margin: 0,
  padding: 0,
  transition: "color 200ms ease-in-out",
  "& b, strong": {
    fontWeight: 600
  },
  "& u": {
    textDecoration: "underline"
  },
  "& i, em": {
    fontStyle: "italic"
  }
})), l = n.forwardRef(
  ({ component: t, className: o = "", ...r }, i) => /* @__PURE__ */ e(
    f,
    {
      className: m("Thr-Text", o),
      as: t,
      ...r,
      ref: i
    }
  )
);
l.displayName = "Text";
export {
  l as default
};
//# sourceMappingURL=Text.js.map
